export default {
  name: 'App',
  created: function created() {
    // 设置 CSS 变量
    document.documentElement.style.setProperty('--primary-color', process.env.VUE_APP_COLOR || '#1890ff');
  }
};